import * as React from 'react';
import { FaCaretDown } from 'react-icons/fa';
import { ButtonInputGroup } from '../button';
import styles from './select-input.scss';
import TextareaAutosize from 'react-textarea-autosize';
import { withForceUpdateConsumer } from 'ui/common/force-update-terminal';
import { removeSoftHyphens } from 'app/infrastructure/platform';

const TextareaWithForceUpdateConsumer = withForceUpdateConsumer(TextareaAutosize);

export interface SelectInputProps {
  inputValue: string;
  placeholder: string;
  onChange: (value: string, openOptionsView?: boolean) => void;
  onFocus?: (inputOffsetLeft: number) => void;
  onBlur?: () => void;
  onOpenOptions?: () => void;
  focus?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  hasSelectedOptions?: boolean;
  inputRef?: (node: HTMLTextAreaElement) => void;
}

export interface SelectInputState {
  hasFocus: boolean;
}

export class SelectInput extends React.PureComponent<SelectInputProps, SelectInputState> {
  public state: Readonly<SelectInputState> = {
    hasFocus: false
  };

  private onOpenOptions = () => {
    this.props?.onOpenOptions?.();
  };

  private onFocus = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const currentTarget = e.currentTarget;
    this.setState({
      hasFocus: true
    }, () => {
      this.props?.onFocus?.(currentTarget.offsetLeft);
    });
  };

  private onBlur = () => {
    this.setState({ hasFocus: false });
    this.props?.onBlur?.();
  };

  private renderOpenOptions = () => {
    if (!this.props.onOpenOptions) {
      return null;
    }
    return (
      <span className="input-group-btn">
        <ButtonInputGroup disabled={this.props.readOnly} onClick={this.onOpenOptions} icon={FaCaretDown} />
      </span>
    );
  };

  private onChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    const currentTarget = e.currentTarget;
    this.props.onChange(removeSoftHyphens(currentTarget.value));
  };

  public render() {
    const { placeholder, focus, readOnly, inputValue = '', hasSelectedOptions, inputRef } = this.props;
    const {
      hasSelectedOptionsStyle,
      readOnlyStyle,
      textarea
    } = styles;

    return (
      <div className={`input-group
                      ${readOnly ? readOnlyStyle : ''}
                      ${hasSelectedOptions ? hasSelectedOptionsStyle : ''}`}>
        <div className={`form-control
                      ${this.state.hasFocus ? 'form-control-focus' : ''}`}
        >
          <TextareaWithForceUpdateConsumer
            autoFocus={focus}
            className={textarea}
            placeholder={placeholder}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            disabled={readOnly}
            value={removeSoftHyphens(inputValue)}
            maxLength={254}
            ref={inputRef}
          />
        </div>
        {this.renderOpenOptions()}
      </div>
    );
  }
}
